/**
 * Drawer DOM and mount: create drawer structure (chat + notes tabs), mount and wire tab/close.
 * Extracted from shell for smaller, single-purpose modules.
 */

import { createEl } from '../core/dom';
import type { DrawerDOMRefs, DrawerShellApi, DrawerTabId } from '../core/types';
import { isRevealPrintPdfMode } from '../reveal-print-core';

export type { DrawerTabId } from '../core/types';

const SIGNIN_CHAT_HTML = '<p class="rf-chat-login-title">Sign in</p><p class="rf-chat-login-desc">Sign in to read and send chat messages.</p><div class="rf-chat-login-error rf-hidden" role="alert"></div><div class="rf-chat-login-buttons"><button type="button" class="rf-chat-login-google"><svg class="rf-login-icon-svg" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59a14.5 14.5 0 0 1 0-9.18l-7.98-6.19a24.03 24.03 0 0 0 0 21.56l7.98-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg> Sign in with Google</button><button type="button" class="rf-chat-login-github"><svg class="rf-login-icon-svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z"/></svg> Sign in with GitHub</button></div>';
const SIGNIN_NOTES_HTML = '<p class="rf-chat-login-title">Sign in</p><p class="rf-chat-login-desc">Sign in to read and save your notes.</p><div class="rf-chat-login-error rf-hidden" role="alert"></div><div class="rf-chat-login-buttons"><button type="button" class="rf-chat-login-google"><svg class="rf-login-icon-svg" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59a14.5 14.5 0 0 1 0-9.18l-7.98-6.19a24.03 24.03 0 0 0 0 21.56l7.98-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg> Sign in with Google</button><button type="button" class="rf-chat-login-github"><svg class="rf-login-icon-svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z"/></svg> Sign in with GitHub</button></div>';
const FULLSCREEN_ENTER_ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="6" width="12" height="12" rx="1.5"/></svg>';
const FULLSCREEN_EXIT_ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 12h12"/></svg>';

/** Compact mode when the drawer is narrow (drawer-shared.css container queries). */
const TAB_ICON_CHAT =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
const TAB_ICON_NOTES =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M16 13H8"/><path d="M16 17H8"/><path d="M10 9H8"/></svg>';
const TAB_ICON_SPEAKER =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 3h20v11H2z"/><path d="M7 21h10"/><path d="M12 17v4"/></svg>';

function appendTabIconAndLabel(btn: HTMLElement, iconSvg: string, label: string, title: string): void {
  const icon = createEl('span', { className: 'rf-drawer-tab-icon', 'aria-hidden': 'true' });
  icon.innerHTML = iconSvg;
  const lab = createEl('span', { className: 'rf-drawer-tab-label' });
  lab.textContent = label;
  btn.setAttribute('title', title);
  btn.setAttribute('aria-label', title);
  btn.appendChild(icon);
  btn.appendChild(lab);
}

const CHAT_INPUT_PLACEHOLDER_OPTIONS = [
  'Ask a question',
  'Ask AI by typing @ai',
  'Give feedback @lectura',
  'Ask @presenter a question',
  'Share a thought',
  'Type @ai for this slide',
  'Message the room…'
];

/** Escape for use inside a double-quoted HTML attribute. */
function escapePlaceholderAttr(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;');
}

function pickChatInputPlaceholder(): string {
  const raw =
    CHAT_INPUT_PLACEHOLDER_OPTIONS[Math.floor(Math.random() * CHAT_INPUT_PLACEHOLDER_OPTIONS.length)] ||
    'Ask a question';
  const maxLen = 44;
  return raw.length > maxLen ? raw.slice(0, maxLen - 1) + '…' : raw;
}

export interface MountDrawerOpts {
  initialOpen?: boolean;
  initialTab?: DrawerTabId;
  onOpenChange?: (open: boolean) => void;
  onTabChange?: (tab: DrawerTabId) => void;
}

export interface CreateDrawerDOMOpts {
  showChatTab?: boolean;
  showNotesTab?: boolean;
  /** Presentation host: third tab for slide `aside.notes` (shown only to presenters). */
  showSpeakerNotesTab?: boolean;
  chatMaxLength?: number;
}

/**
 * Create full drawer DOM matching plugin/lectura: auth loading, login, chat (messages+form), notes (sign-in+editor).
 */
export function createDrawerDOM(opts: CreateDrawerDOMOpts = {}): DrawerDOMRefs {
  const { showChatTab = true, showNotesTab = true, showSpeakerNotesTab = false, chatMaxLength = 500 } = opts;
  const drawer = createEl('div', { className: 'rf-drawer', id: 'rf-drawer', 'aria-hidden': 'true' });
  const inner = createEl('div', { className: 'rf-drawer-inner' });
  const body = createEl('div', { className: 'rf-drawer-body' });

  const header = createEl('div', { className: 'rf-drawer-header' });
  const tabsEl = createEl('div', {
    className: 'rf-drawer-tabs',
    role: 'tablist',
    'aria-label': 'Chat, my notes, or speaker notes'
  });
  const tabChat = createEl('button', { type: 'button', className: 'rf-drawer-tab rf-drawer-tab-active', role: 'tab', 'aria-selected': 'true', 'aria-controls': 'rf-drawer-chat-panel', id: 'rf-drawer-tab-chat' });
  appendTabIconAndLabel(tabChat, TAB_ICON_CHAT, 'Chat', 'Chat');
  const chatBadge = createEl('span', { className: 'rf-drawer-tab-badge rf-hidden', html: '0' });
  tabChat.appendChild(chatBadge);
  const tabNotes = createEl('button', { type: 'button', className: 'rf-drawer-tab', role: 'tab', 'aria-selected': 'false', 'aria-controls': 'rf-drawer-notes-panel', id: 'rf-drawer-tab-notes' });
  appendTabIconAndLabel(tabNotes, TAB_ICON_NOTES, 'My notes', 'My notes');
  const notesIndicator = createEl('span', { className: 'rf-drawer-tab-notes-indicator rf-drawer-tab-notes-empty', 'aria-label': 'No note for this slide' });
  tabNotes.appendChild(notesIndicator);
  let tabSpeaker: HTMLElement | null = null;
  if (showChatTab) tabsEl.appendChild(tabChat);
  if (showNotesTab) tabsEl.appendChild(tabNotes);
  if (showSpeakerNotesTab) {
    tabSpeaker = createEl('button', {
      type: 'button',
      className: 'rf-drawer-tab rf-hidden',
      role: 'tab',
      'aria-selected': 'false',
      'aria-controls': 'rf-drawer-speaker-panel',
      id: 'rf-drawer-tab-speaker'
    });
    appendTabIconAndLabel(tabSpeaker, TAB_ICON_SPEAKER, 'Speaker notes', 'Speaker notes');
    tabsEl.appendChild(tabSpeaker);
  }

  const headerRight = createEl('div', { className: 'rf-drawer-header-right' });
  const fullscreenBtn = createEl('button', {
    type: 'button',
    className: 'rf-drawer-fullscreen-toggle',
    'aria-label': 'Expand panel',
    title: 'Expand panel'
  });
  fullscreenBtn.innerHTML = FULLSCREEN_ENTER_ICON;
  const closeBtn = createEl('button', { type: 'button', className: 'rf-drawer-close', 'aria-label': 'Close' });
  closeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  headerRight.appendChild(fullscreenBtn);
  headerRight.appendChild(closeBtn);
  header.appendChild(tabsEl);
  header.appendChild(headerRight);
  body.appendChild(header);

  const chatWrap = createEl('div', { className: 'rf-drawer-chat-wrap rf-drawer-panel-active' });
  chatWrap.id = 'rf-drawer-chat-panel';
  const notesWrap = createEl('div', { className: 'rf-drawer-notes-wrap rf-hidden' });
  notesWrap.id = 'rf-drawer-notes-panel';
  tabChat.setAttribute('aria-controls', 'rf-drawer-chat-panel');
  tabNotes.setAttribute('aria-controls', 'rf-drawer-notes-panel');

  const authLoading = createEl('div', { className: 'rf-chat-auth-loading' });
  authLoading.innerHTML = '<div class="rf-chat-loading" role="status" aria-live="polite"><span class="rf-chat-loading-spinner" aria-hidden="true"></span><span class="rf-chat-loading-text">Checking sign-in…</span></div>';
  chatWrap.appendChild(authLoading);

  const loginPanel = createEl('div', { className: 'rf-chat-login rf-hidden' });
  loginPanel.innerHTML = SIGNIN_CHAT_HTML;
  const chatLoginError = loginPanel.querySelector('.rf-chat-login-error');
  chatWrap.appendChild(loginPanel);

  const chatPanel = createEl('div', { className: 'rf-chat-panel rf-hidden' });
  chatPanel.innerHTML =
    '<div class="rf-chat-messages"></div><div class="rf-chat-scroll-bottom-wrap"><button type="button" class="rf-chat-scroll-bottom rf-hidden" aria-label="Scroll to latest message" title="Scroll to latest">Jump to latest</button></div><div class="rf-chat-form"><div class="rf-chat-reply-preview rf-hidden"><span class="rf-chat-reply-preview-text"></span><button type="button" class="rf-chat-reply-preview-cancel" aria-label="Cancel reply">Cancel</button></div><textarea class="rf-chat-input" placeholder="' +
    escapePlaceholderAttr(pickChatInputPlaceholder()) +
    '" rows="2" maxlength="' +
    chatMaxLength +
    '"></textarea><div class="rf-chat-form-error rf-hidden" role="alert"></div><button type="button" class="rf-chat-send">Send</button></div>';
  chatWrap.appendChild(chatPanel);
  const chatMessages = chatPanel.querySelector('.rf-chat-messages');
  const chatInput = chatPanel.querySelector('.rf-chat-input');
  const chatFormError = chatPanel.querySelector('.rf-chat-form-error');
  const chatSendBtn = chatPanel.querySelector('.rf-chat-send');
  const chatReplyPreview = chatPanel.querySelector('.rf-chat-reply-preview');
  const chatReplyPreviewText = chatPanel.querySelector('.rf-chat-reply-preview-text');
  const chatReplyPreviewCancel = chatPanel.querySelector('.rf-chat-reply-preview-cancel');
  const chatScrollBottomBtn = chatPanel.querySelector('.rf-chat-scroll-bottom');

  const notesPanel = createEl('div', { className: 'rf-notes-panel' });
  const notesLoginPanel = createEl('div', { className: 'rf-chat-login rf-hidden' });
  notesLoginPanel.setAttribute('aria-live', 'polite');
  notesLoginPanel.innerHTML = SIGNIN_NOTES_HTML;
  notesPanel.appendChild(notesLoginPanel);
  const notesEditorWrapEl = createEl('div', { className: 'rf-notes-editor-wrap rf-hidden' });
  notesEditorWrapEl.innerHTML =
    '<textarea class="rf-notes-textarea" placeholder="Your notes for this slide…" rows="6" maxlength="10000" aria-label="My notes"></textarea>' +
    '<div class="rf-notes-editor-footer">' +
    '<div class="rf-notes-status" aria-live="polite"><span class="rf-notes-status-text"></span></div>' +
    '<button type="button" class="rf-notes-summary-btn" title="Open a printable summary (slides and your notes) in a new tab">Summary overview</button>' +
    '</div>';
  notesPanel.appendChild(notesEditorWrapEl);
  const notesTextarea = notesEditorWrapEl.querySelector('.rf-notes-textarea');
  const notesStatus = notesEditorWrapEl.querySelector('.rf-notes-status');
  const notesStatusText = notesEditorWrapEl.querySelector('.rf-notes-status-text');

  notesWrap.appendChild(notesPanel);

  let speakerWrap: HTMLElement | null = null;
  let speakerNotesBody: HTMLElement | null = null;
  let speakerNotesFontDec: HTMLElement | null = null;
  let speakerNotesFontInc: HTMLElement | null = null;
  if (showSpeakerNotesTab) {
    speakerWrap = createEl('div', { className: 'rf-drawer-speaker-wrap rf-hidden' });
    speakerWrap.id = 'rf-drawer-speaker-panel';
    const toolbar = createEl('div', { className: 'rf-speaker-notes-toolbar' });
    toolbar.innerHTML =
      '<span class="rf-sn-toolbar-label">Text size</span>' +
      '<button type="button" class="rf-sn-font-btn rf-sn-font-dec" aria-label="Smaller text" title="Smaller">A−</button>' +
      '<button type="button" class="rf-sn-font-btn rf-sn-font-inc" aria-label="Larger text" title="Larger">A+</button>';
    speakerNotesFontDec = toolbar.querySelector('.rf-sn-font-dec');
    speakerNotesFontInc = toolbar.querySelector('.rf-sn-font-inc');
    speakerNotesBody = createEl('div', {
      className: 'rf-speaker-notes-body',
      role: 'region',
      'aria-label': 'Speaker notes for this slide'
    });
    speakerWrap.appendChild(toolbar);
    speakerWrap.appendChild(speakerNotesBody);
  }

  const stackedFooterSpacer = createEl('div', {
    className: 'rf-drawer-stacked-footer-spacer',
    'aria-hidden': 'true'
  });

  const resizeHandle = createEl('div', {
    className: 'rf-drawer-resize-handle',
    role: 'separator',
    'aria-label': 'Resize chat panel',
    title: 'Drag to resize. Double-click to reset.',
    tabindex: '0'
  });

  body.appendChild(chatWrap);
  body.appendChild(notesWrap);
  if (speakerWrap) body.appendChild(speakerWrap);
  body.appendChild(stackedFooterSpacer);
  inner.appendChild(body);
  drawer.appendChild(inner);
  /* After inner so the strip sits above it and receives pointer events (inner is full-bleed). */
  drawer.appendChild(resizeHandle);

  return {
    drawer,
    header,
    slideNumEl: null,
    closeBtn,
    tabChat,
    tabNotes,
    chatWrap,
    notesWrap,
    chatAuthLoading: authLoading,
    chatLoginPanel: loginPanel,
    chatLoginError,
    chatPanel,
    chatMessages,
    chatInput,
    chatFormError,
    chatSendBtn,
    chatReplyPreview,
    chatReplyPreviewText,
    chatReplyPreviewCancel,
    chatScrollBottomBtn,
    drawerTabChatBadge: chatBadge,
    drawerTabNotesIndicator: notesIndicator,
    notesPanel,
    notesSigninMsg: notesLoginPanel,
    notesEditorWrap: notesEditorWrapEl,
    notesTextarea,
    notesStatus,
    notesStatusText,
    tabSpeaker,
    speakerWrap,
    speakerNotesBody,
    speakerNotesFontDec,
    speakerNotesFontInc,
    stackedFooterSpacer,
    resizeHandle
  };
}

/**
 * Mount drawer and wire tab/close. Returns open/close/toggle/setTitle and getDrawer.
 */
export function mountDrawer(container: HTMLElement, dom: DrawerDOMRefs, opts: MountDrawerOpts = {}): DrawerShellApi {
  const { drawer, closeBtn, chatWrap, notesWrap, tabChat, tabNotes, tabSpeaker, speakerWrap } = dom;
  const fullscreenBtn = drawer.querySelector('.rf-drawer-fullscreen-toggle') as HTMLButtonElement | null;
  container.appendChild(drawer);
  let desktopFullscreen = false;
  let mobileFullscreen = false;
  let currentTab: DrawerTabId = 'chat';

  function isStackedLayout(): boolean {
    return container.classList.contains('rf-layout-stacked') || container.classList.contains('rf-layout-fullscreen');
  }

  function syncFullscreenUi(): void {
    const open = drawer.classList.contains('rf-open');
    const stacked = isStackedLayout();
    if (stacked && desktopFullscreen) desktopFullscreen = false;
    if (!stacked && mobileFullscreen) mobileFullscreen = false;
    container.classList.toggle('rf-layout-desktop-fullscreen', open && desktopFullscreen && !stacked);
    container.classList.toggle('rf-layout-mobile-fullscreen', open && mobileFullscreen && stacked);
    if (!fullscreenBtn) return;
    if (stacked) {
      const isFull = open && mobileFullscreen;
      fullscreenBtn.setAttribute('aria-label', isFull ? 'Minimize panel' : 'Maximize panel');
      fullscreenBtn.setAttribute('title', isFull ? 'Minimize panel' : 'Maximize panel');
      fullscreenBtn.innerHTML = isFull ? FULLSCREEN_EXIT_ICON : FULLSCREEN_ENTER_ICON;
      return;
    }
    fullscreenBtn.setAttribute('aria-label', desktopFullscreen ? 'Restore panel size' : 'Expand panel');
    fullscreenBtn.setAttribute('title', desktopFullscreen ? 'Restore panel size' : 'Expand panel');
    fullscreenBtn.innerHTML = desktopFullscreen ? FULLSCREEN_EXIT_ICON : FULLSCREEN_ENTER_ICON;
  }

  function emitOpenChange(): void {
    opts.onOpenChange?.(drawer.classList.contains('rf-open'));
  }

  function setOpen(next: boolean): void {
    drawer.classList.toggle('rf-open', next);
    drawer.setAttribute('aria-hidden', next ? 'false' : 'true');
    if (!next && desktopFullscreen) {
      desktopFullscreen = false;
    }
    if (!next && mobileFullscreen) {
      mobileFullscreen = false;
    }
    syncFullscreenUi();
    emitOpenChange();
  }

  function setActiveTab(tab: DrawerTabId): void {
    const notesEnabled = !!tabNotes.parentElement;
    const speakerSlot = !!(tabSpeaker && speakerWrap && tabSpeaker.parentElement);
    const speakerTabUsable = speakerSlot && !tabSpeaker!.classList.contains('rf-hidden');

    let nextTab: DrawerTabId = tab;
    if (nextTab === 'notes' && !notesEnabled) nextTab = 'chat';
    if (nextTab === 'speaker' && !speakerTabUsable) nextTab = 'chat';

    chatWrap.classList.toggle('rf-drawer-panel-active', nextTab === 'chat');
    chatWrap.classList.toggle('rf-hidden', nextTab !== 'chat');
    notesWrap.classList.toggle('rf-drawer-panel-active', nextTab === 'notes');
    notesWrap.classList.toggle('rf-hidden', nextTab !== 'notes');
    if (speakerWrap) {
      speakerWrap.classList.toggle('rf-drawer-panel-active', nextTab === 'speaker');
      speakerWrap.classList.toggle('rf-hidden', nextTab !== 'speaker');
    }

    tabChat.classList.toggle('rf-drawer-tab-active', nextTab === 'chat');
    tabChat.setAttribute('aria-selected', nextTab === 'chat' ? 'true' : 'false');
    tabNotes.classList.toggle('rf-drawer-tab-active', nextTab === 'notes');
    tabNotes.setAttribute('aria-selected', nextTab === 'notes' ? 'true' : 'false');
    if (tabSpeaker) {
      tabSpeaker.classList.toggle('rf-drawer-tab-active', nextTab === 'speaker');
      tabSpeaker.setAttribute('aria-selected', nextTab === 'speaker' ? 'true' : 'false');
    }

    currentTab = nextTab;
    opts.onTabChange?.(nextTab);
  }

  function open(): void {
    setOpen(true);
  }
  function close(): void {
    setOpen(false);
  }
  function toggle(): void {
    setOpen(!drawer.classList.contains('rf-open'));
  }

  closeBtn.addEventListener('click', close);
  fullscreenBtn?.addEventListener('click', () => {
    if (isStackedLayout()) {
      mobileFullscreen = !mobileFullscreen;
      syncFullscreenUi();
      return;
    }
    desktopFullscreen = !desktopFullscreen;
    syncFullscreenUi();
  });

  const onViewportResize = (): void => {
    syncFullscreenUi();
  };
  window.addEventListener('resize', onViewportResize, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', onViewportResize, { passive: true });
  }

  document.addEventListener('keydown', (e: KeyboardEvent) => {
    if (isRevealPrintPdfMode()) return;
    if (e.key === 'Escape' && drawer.classList.contains('rf-open')) {
      close();
    }
  });

  tabChat.addEventListener('click', () => {
    setActiveTab('chat');
  });
  tabNotes.addEventListener('click', () => {
    setActiveTab('notes');
  });
  tabSpeaker?.addEventListener('click', () => {
    setActiveTab('speaker');
  });

  setActiveTab(opts.initialTab ?? 'chat');
  setOpen(!!opts.initialOpen);
  syncFullscreenUi();

  return {
    open,
    close,
    toggle,
    setTitle(_slideNum: number) {
      /* Slide number removed from drawer header (space). */
    },
    getDrawer: () => drawer,
    setTab: setActiveTab,
    getActiveTab: () => currentTab
  };
}
